import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PatientRepository, Plan } from '../core';
import { BaseService } from './base.service';


/**
 * This service handles plan data.
 */
@Injectable({ providedIn: 'root' })
export class PlanService extends BaseService {

	private readonly patientRepo = inject(PatientRepository);


	/**
	* Get plan by plan guid.
	* @param {string} planGuid The plan guid.
	*/
	getPlan(planGuid: string): Observable<Plan> {
		return this.patientRepo.getPlan(planGuid).pipe(
			map(res => this._handleApiResponse(res))
		);
	}

}
